import { render, staticRenderFns } from "./QuickOptionComponent.vue?vue&type=template&id=d9d866a0&"
import script from "./QuickOptionComponent.vue?vue&type=script&lang=ts&"
export * from "./QuickOptionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuickOptionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports